<template>
	<div class="user">
		<div class="content">
			<p class="info-user">常见问题：什么是预加解封？ 什么是直接解封？保费是什么？</p>
			<div class="info-left">
				<router-link  to="/userInfo">个人信息</router-link>
				<router-link to="/account">账号管理</router-link>
				<router-link to="/finance">资金管理</router-link>
			</div>
			<div class="info-right">
				 <router-view></router-view>
			</div>
		</div>
	</div>
</template>
<style scoped>
	.user{background: #f5f5f5; padding-bottom:30px;}
	.user .info-right{float:right;width:73%;background: #fff; padding:20px 2% 30px;font-size:16px;color:#444; line-height: 32px;}
	.user .info-user{ font-size:16px; color:#444444; font-weight: normal; height:60px; line-height: 60px;}
	.user .info-left{float:left;width:20%; background: #fff;}
	.user .info-left a{display: block;font-size:16px; color:#666;height:50px; line-height:50px;padding-left:50px; font-weight: normal; cursor: pointer; text-decoration: none;}
	.user .info-left a.router-link-active{border-left:solid 2px #5190ff; background: #e3edff; color:#5190ff;}
</style>
<script>   
	export default {
		name: 'user',
		methods: {
		},
		data() {
			return {
				
			}
		},
		computed:{
			
		},
		mounted: function () {
			
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/user.vue